import Vue from 'vue';
import App from './App.vue';

// C端代码做按需引入，按需在自己的业务逻辑里
// import { Button } from 'vant';
// import Vant from 'vant';
// import 'vant/lib/index.css';

import request from './api';
import router from './router';

import '@/styles/index.less';

Vue.config.productionTip = false;

// vant
// Vue.use(Vant);

// 请求
Vue.use(request);

new Vue({
  render: h => h(App),
  router
}).$mount('#app');
